import moment from "moment"

interface Props {
  title: string
  subtitle?: string
}

const PageHeader = ({ title, subtitle }: Props) => (
  <div className={"titleDatesContainer"}>
    <div>
      <h1 className={"title"}>{title}</h1>
      <h6 className={"date"}>
        {subtitle ? subtitle : moment().format("dddd, MMM D, YYYY")}
      </h6>
    </div>
  </div>
)

export default PageHeader
